
import AlignTop from "../../../assets/duotone/AlignTop.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AlignTopIcon({ className, dataTestid = "AlignTopIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AlignTop data-testid={dataTestid} className={classes} {...rest} />
  );
}
